var _g, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPerekid(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "\\u0421\\u043B\\u043E\\u0439_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 165 210",
    enableBackground: "new 0 0 165 210",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 13.7,
    y: 19.7,
    fill: "#FFFFFF",
    width: 140,
    height: 179.6
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#B2B1B1",
    d: "M154.7,200.4H12.6V18.7h142.1V200.4z M14.7,198.3h137.9V20.8H14.7V198.3z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 144,
    y: 11.6,
    fill: "#B2B1B1",
    width: 2.1,
    height: 13.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 135.2,
    y: 11.6,
    fill: "#B2B1B1",
    width: 2.1,
    height: 13.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.4,
    y: 11.6,
    fill: "#B2B1B1",
    width: 2.1,
    height: 13.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.6,
    y: 11.6,
    fill: "#B2B1B1",
    width: 2.1,
    height: 13.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 108.8,
    y: 11.6,
    fill: "#B2B1B1",
    width: 2.1,
    height: 13.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 100,
    y: 11.6,
    fill: "#B2B1B1",
    width: 2.1,
    height: 13.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.8,
    y: 11.6,
    fill: "#B2B1B1",
    width: 2.1,
    height: 13.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 56,
    y: 11.6,
    fill: "#B2B1B1",
    width: 2.1,
    height: 13.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.2,
    y: 11.6,
    fill: "#B2B1B1",
    width: 2.1,
    height: 13.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 38.4,
    y: 11.6,
    fill: "#B2B1B1",
    width: 2.1,
    height: 13.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 29.6,
    y: 11.6,
    fill: "#B2B1B1",
    width: 2.1,
    height: 13.7
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20.8,
    y: 11.6,
    fill: "#B2B1B1",
    width: 2.1,
    height: 13.7
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "none",
    stroke: "#AFAFAF",
    strokeWidth: 2.0001,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeMiterlimit: 22.9256,
    d: " M41.4,15.7h33.8c1.3,0,2.5-0.9,2.8-2.1c1.5-5.7,9.6-5.7,11.2,0c0.3,1.3,1.5,2.1,2.8,2.1h33.8"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerekid);
export default __webpack_public_path__ + "static/media/perekid.1174a34f5ef6bebffab4d7fd5b2b02f5.svg";
export { ForwardRef as ReactComponent };